import PropTypes from 'prop-types';

const sxPropType = PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.array]);

export default sxPropType;
